<!--
 * @FileDescription: 商品管理的tab（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-06-28（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
 <div class="manage-box">
     <a-table :columns="columns"
              :dataSource="dataSource"
              :pagination="pagination1"
              @change="handleTableChange"
              class="table-height"
              bordered
              :rowClassName="rowClassName"
              :scroll="{ y:'calc(100vh - 475px)' }"
              rowKey="key">
         <template slot="img" slot-scope="text, record">
             <viewer :images="record.photos" v-if="!isEmpty(record.pictureUrl)">
                 <img :src="record.pictureUrl"  class="table-img"/>
             </viewer>
             <img src="@/assets/image/default-img.png" v-else class="table-img"/>
         </template>
         <template slot="name" slot-scope="text, record">
             <div class="table-name"><img v-if="record.assemblyFlag == 1" src="@/assets/image/manage_zong@2x.png" style="width: 22px;margin-right: 5px"/>
                 <a-tooltip placement="top" >
                     <template slot="title">
                        <span>{{text}}</span>
                     </template>
                      {{text}}
                 </a-tooltip>
             </div>
         </template>
         <template slot="state" slot-scope="text, record">
             <span class="table-cir" :class="text == 1 ? '' :'table-cir-warn'"></span>
            <span v-if="text == 1"> 正常</span>
             <span v-else> 禁用</span>
         </template>
         <template slot="operation" slot-scope="text, record">
             <div class="operation">
                 <div class="operation-item" @click="onEdit(1,record)" v-has="'commodity_shop_add'">编辑</div>
                 <div class="operation-item" @click="onEdit(2,record)" v-has="'commodity_shop_edit'">复制</div>
                 <div class="operation-item" @click="onEdit(3,record)" v-has="'commodity_shop_delete'">
                     <a href="javascript:;" >
                         <img src="@/assets/image/cha_shanchu_color.png" class="operation-item-img" />
                         <img src="@/assets/image/cha_shanchu.png" class="operation-item-img1"/>
                     </a>
                     <!--<a-popconfirm-->
                             <!--v-if="dataSource.length"-->
                             <!--title="确定删除?"-->
                             <!--@confirm="() => onEdit(3,record)"-->
                     <!--&gt;-->
                        <!---->
                     <!--</a-popconfirm>-->
                 </div>
             </div>
         </template>
     </a-table>
     <deleteModal ref="deleteModal" @confirmDeletion="confirmDeletion"></deleteModal>
 </div>
</template>
<script>
import {shopList,productDelete} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import deleteModal from '@/components/module/deleteModal'
export default {
    mixins:[mixins],
    props:{
        dataSource:{
            type:Array,
            default:[]
        },
        pagination1:{
            type:Object,
        }
    },
    data(){
        return{
            columns: [
                {
                    title: '序号',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 80,
                    align: 'center',
                    customRender(t, r, index) {
                        return parseInt(index) + 1
                    }
                },
                {
                    title: '商品图片',
                    key: 'storageResourceUrl',
                    align: 'center',
                    dataIndex: 'storageResourceUrl',
                    width:100,
                    scopedSlots: { customRender: 'img' },
                },
                {
                    title: '商品名称',
                    dataIndex: 'name',
                    key: 'name',
                    width:180,
                    ellipsis: true,
                    scopedSlots: { customRender: 'name' },
                },
                {
                    title: '型号',
                    key: 'model',
                    dataIndex: 'model',
                    ellipsis: true,
                },
                {
                    title: '规格',
                    key: 'specification',
                    dataIndex:'specification',
                    ellipsis: true,
                },
                {
                    title: '单位',
                    key: 'unit',
                    dataIndex:'unit',
                    ellipsis: true,
                },
                {
                    title: '零售价',
                    key: 'retailPrice',
                    align: 'right',
                    dataIndex:'retailPrice',
                    ellipsis: true,
                },
                {
                    title: '适配机型',
                    key: 'adaptiveModelName',
                    dataIndex:'adaptiveModelName',
                    ellipsis: true,
                },
                {
                    title: '品牌',
                    key: 'brandName',
                    ellipsis: true,
                    dataIndex:'brandName',
                },
                {
                    title: '状态',
                    key: 'status',
                    ellipsis: true,
                    dataIndex:'status',
                    scopedSlots: { customRender: 'state' },
                },
                {
                    title: '操作',
                    width:150,
                    scopedSlots: { customRender: 'operation' },
                },
            ],
        }
    },
    watch: {
        dataSource(newVal,oldVal){
            newVal.forEach((item)=>{
                item.photos = []
                item.photos.push(item.pictureUrl)
            })
        }
    },
    mounted ()   {
    },
    created () {

    },
    components: {
        deleteModal

    },
    methods: {
        rowClassName(record,index){
            let className = ''
            if(record.status == 2){
                className = 'tab-row-warn'
            }
            return className
        },
        /**
         * @description: 表格页数切换（方法描述）
         */
        handleTableChange(pagination, filters, sorter){
            this.$emit('handleTableChange',pagination)
        },
        /**
         * @description:操作（方法描述）
         */
        onEdit(index,record){
            if(index == 1){
                this.$emit('EditManage',index,record,1)
            }else if(index == 2){
                this.$emit('EditManage',index,record,2)
            }else if(index == 3){
                record.content = '您确认要删除商品吗'
                this.$refs.deleteModal.show(record)
            }
        },
        confirmDeletion(record){
            this.$emit('EditManage',3,record,3)
        }

    },

}
</script>
<style lang="scss">
    .table-height{
        .ant-table-tbody > tr > td:nth-child(2){
            padding: 7px 16px;
        }
        .ant-table-wrapper{
            padding: 0;
        }
        .ant-table{
            height: calc(100vh - 350px);
            .ant-table-tbody > tr > td{
                height: 60px;
                padding: 10px 10px;
            }
        }
        .ant-table-body,.ant-table-body-inner,.ant-table-body-outer{
            max-height:calc(100vh - 410px)!important;
        }
    }

</style>
<style scoped lang="scss">
    .table-height{
        .table-name{
            width: 100%;
            display: inline-block;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
        }
    }
    .table-img{
        width: 35px;
        height: 35px;
    }
    .table-cir{
        display: inline-block;
        width:4px;
        height:4px;
        background:rgba(53,173,0,1);
        border-radius:50%;
        margin-bottom: 3px;
    }
    .table-cir-warn{
        background:#FF0000;
    }
    .operation{
        display: flex;
        align-items: center;
        .operation-item{
            cursor: pointer;
            font-size: 14px;
            color: #387BFC;
            margin-left: 10px;
            img{
                width: 16px;
            }
        }
        .operation-item:hover{
            .operation-item-img{
                display: none;
            }
            .operation-item-img1{
                display: block;
            }
        }
        .operation-item-img{
            display: block;
        }
        .operation-item-img1{
            display: none;
        }
    }
</style>
